import { createImagePicker } from "../imagePicker.js";

export function structureSave(id) {
  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-floppy"></i> Speichern & Dankeseite</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Titel Dankeseite</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-titel placeholder="Vielen Dank!">
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Text Dankeseite</label>
                        <div class="col-12">
                            <textarea class="form-control form-control-sm" df-text placeholder="Deine Antworten wurden erfolgreich gespeichert."></textarea>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Bild (optional)</label>
                        <div class="col-12">
                            ${createImagePicker(id, "frageimg", "df-frageimg")}
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Neustart-Verhalten</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm" df-autoreload>
                                <option value="none">Keine Aktion (einfach nur Danke & Text)</option>
                                <option value="false">Neustart-Button anzeigen</option>
                                <option value="true">Automatisch neu starten (Kiosk-Modus)</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
}
